<template>
  <div v-if="pendingUsers.length > 0" class="pending-section mb-6">
    <h3 class="text-h6 mb-3">� Pending User Approvals</h3>
    <v-card
      v-for="user in pendingUsers"
      :key="user.id"
      class="mb-2"
      variant="outlined"
    >
      <v-card-text class="d-flex justify-space-between align-center">
        <div>
          <div class="font-weight-bold">{{ user.username }}</div>
          <div class="text-caption text-grey">{{ user.email }}</div>
        </div>
        <div class="d-flex ga-2">
          <v-btn
            color="success"
            size="small"
            @click="$emit('approve', user)"
          >
            <v-icon start>mdi-check</v-icon>
            Approve
          </v-btn>
          <v-btn
            color="error"
            size="small"
            variant="outlined"
            @click="$emit('reject', user)"
          >
            <v-icon start>mdi-close</v-icon>
            Reject
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <v-divider class="my-6"></v-divider>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable no-undef */
interface User {
  id: string
  username?: string
  first_name?: string
  last_name?: string
  email: string
  status: string
}

interface Props {
  pendingUsers: User[]
}

defineProps<Props>()

defineEmits(['approve', 'reject'])


</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

.pending-section h3 {
  color: var(--primary-color, #2c4a6b);
  font-family: 'Poppins', sans-serif;
}
</style>
